import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import TaskDescriptionModal from "../Modal/taskDescriptionModal";

const SubstationNetwork = ({ currentScript, isTaskCompleted }) => {
  const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
  const openTaskModal = () => {
    setIsTaskModalVisible(true);
  };
  const closeTaskModal = () => {
    setIsTaskModalVisible(false);
  };
  return (
    <React.Fragment>
      {currentScript && (
        <div className="w-full h-full">
          <h1 className="text-2xl text-center mt-2">Substation Network</h1>

          {"img" in currentScript && (
            <div className="relative w-full mt-6">
              {!isTaskCompleted && "alertLabel" in currentScript && (
                <div
                  className="animate-pulse absolute -top-8 right-2 flex gap-2 text-red-500 font-bold border rounded-full p-1 md:p-2 border-red-500 items-center shadow-lg shadow-red-500 cursor-pointer hover:scale-105 transition-all ease-out duration-100"
                  onClick={openTaskModal}
                >
                  <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    className="text-lg md:text-3xl"
                  />
                  <h4 className="text-base md:text-lg">
                    {currentScript["alertLabel"]}
                  </h4>
                </div>
              )}
              {"taskDescription" in currentScript && (
                <TaskDescriptionModal
                  isVisible={isTaskModalVisible}
                  message={currentScript["taskDescription"]}
                  onClose={closeTaskModal}
                />
              )}
              <div className="hidden min-[640px]:flex rounded-lg p-4 items-center">
                <img
                  src={require(`../../static/images/visuals/${
                    isTaskCompleted
                      ? currentScript["img"] + "_Next"
                      : currentScript["img"]
                  }.png`)}
                  alt="Control Room Network"
                  className="w-full rounded-lg"
                />
              </div>
              <div className="flex min-[640px]:hidden rounded-lg p-4 items-center mt-8">
                <img
                  src={require(`../../static/images/visuals/${
                    isTaskCompleted
                      ? currentScript["img"] + "_mobile_Next"
                      : currentScript["img"] + "_mobile"
                  }.png`)}
                  alt="Control Room Network"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default SubstationNetwork;
